// Copyright (C) 2020 Intel Corporation
//
// SPDX-License-Identifier: MIT

import React from 'react';
import { Row, Col } from 'antd/lib/grid';
import Select from 'antd/lib/select';
import Button from 'antd/lib/button';
import Text from 'antd/lib/typography/Text';
import { useTranslation } from 'react-i18next';
import { EyesTooltip as Tooltip } from 'utils/custom-antd';

interface Props {
    labels: any[];
    selectedLabeID: number;
    repeatShapeShortcut: string;
    onChangeLabel(value: string): void;
    onSetup(
        labelID: number,
    ): void;
}

function SetupTagPopover(props: Props): JSX.Element {
    const {
        labels,
        selectedLabeID,
        repeatShapeShortcut,
        onChangeLabel,
        onSetup,
    } = props;
    const { t } = useTranslation();

    return (
        <div className='cvat-draw-shape-popover-content'>
            <Row justify='start'>
                <Col>
                    <Text className='cvat-text-color' strong>{t('Setup tag')}</Text>
                </Col>
            </Row>
            <Row justify='start'>
                <Col>
                    <Text className='cvat-text-color'>{t('Label')}</Text>
                </Col>
            </Row>
            <Row justify='center'>
                <Col span={24}>
                    <Select
                        value={`${selectedLabeID}`}
                        onChange={onChangeLabel}
                    >
                        {
                            labels.map((label: any) => (
                                <Select.Option
                                    key={label.id}
                                    value={`${label.id}`}
                                >
                                    {label.name}
                                </Select.Option>
                            ))
                        }
                    </Select>
                </Col>
            </Row>
            <Row justify='space-around'>
                <Col span={24}>
                    <Tooltip title={t('Press {{repeatShapeShortcut}} to add a tag again', { repeatShapeShortcut })}>
                        <Button onClick={() => onSetup(selectedLabeID)}>
                            Tag
                        </Button>
                    </Tooltip>
                </Col>
            </Row>
        </div>
    );
}

export default React.memo(SetupTagPopover);
